/**
 * A/B: trust API NexLoc / Progress inches_per_pixel for tour pitch.
 * Pair with floor fetch `?include_untrusted_tour_metrology=1` (fetchFloor adds
 * that when this is true). useFloorImages includes this in its react-query key.
 */
export function resolveTourUseIpp(search: string): boolean {
  const raw = new URLSearchParams(search).get('tourUseIpp')
  if (raw == null || raw === '') {
    return false
  }
  const lower = raw.toLowerCase()
  return raw === '1' || lower === 'true' || lower === 'on' || lower === 'yes'
}
